<template>
  <div v-for="item in currentSidebarConfig" :key="item.title">
    <!--Section divider-->
    <div v-if="item.section" class="mb-3 mt-1 h-px w-full bg-gray-700/50"></div>

    <router-link
      v-else
      :to="item.website ? `/${$route.params.websiteId || '1'}${item.path}` : item.path"
      :class="[
                'trans-150 group mb-2 flex select-none items-center rounded-lg p-2',
                // Active element highlight
                $route.path.includes(item.path)
                    ? 'bg-[#29293d]/75 text-gray-100'
                    : 'text-gray-400 hover:bg-[#29293d]/75 hover:text-gray-300',
            ]"
      :data-test-id="`sidebar-${item.path.replaceAll('/', '')}`"
    >
      <div
        :class="[
                            $route.path.includes(item.path)
                                ? 'text-blue-500'
                                : 'text-blue-300/30 group-hover:text-blue-300/60',
                            'trans-150 h-[22px] w-[22px] shrink-0',
                        ]"
      >
        <div v-if="item.icon_html" v-html="item.icon"></div>
        <component v-else :is="item.icon" />
      </div>

      <div
        v-if="!snp.context.sidebarMinimized"
        class="ml-3.5 whitespace-nowrap text-sm font-normal tracking-wide"
      >
        {{ item.title }}
      </div>
    </router-link>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    components: {

    },
    props: {
        currentSidebarConfig: {
            type: Object,
            required: true
        },
        snapshot: {
            type: Object,
            required: true
        },

    },

    setup(props) {
        const snp = props.snapshot

        return {snp}
    }

})
</script>
